// @ts-nocheck
// src/components/Dashboard/Dashboard.jsx

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { clearAuthToken } from '../../services/authService';
import { useLanguage } from '../../contexts/LanguageContext';
import CountUpAnimation from '../CountUpAnimation';

const Dashboard = () => {
  const { t, isRTL } = useLanguage();
  
  const employeeSections = useMemo(() => [
    { title: t('personalDataUpdate'), description: t('personalDataUpdateDesc'), link: '/dashboard/profile', disabled: false },
    { title: t('employmentData'), description: t('employmentDataDesc'), link: '#', disabled: true },
    { title: t('contactData'), description: t('contactDataDesc'), link: '#', disabled: true },
  ], [t]);

  const handleLogout = () => {
    clearAuthToken();
    window.location.href = '/benefaction/login';
  };

  return (
    <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="bg-gradient-to-r from-sa-700 via-sa-500 to-sa-700 py-16 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className={`flex flex-col md:flex-row md:items-center md:justify-between gap-6 ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}>
            <div className={isRTL ? 'text-right' : 'text-left'}>
              <h1 className="text-3xl md:text-4xl font-bold mb-3">{t('dashboardWelcome')}</h1>
              <p className="text-base md:text-lg text-white/90 max-w-2xl">
                {t('dashboardWelcomeDesc')}
              </p>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className={`self-start inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-5 py-2.5 rounded-xl transition-all ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ transform: isRTL ? 'none' : 'rotate(180deg)' }}>
                <path d="M15 3h4v18h-4" />
                <path d="M10 17l5-5-5-5" />
                <path d="M15 12H3" />
              </svg>
              {t('logout')}
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {useMemo(() => [{
            title: t('profileCompletion'),
            value: 100,
            suffix: '%',
            isNumeric: true,
            note: t('allDataComplete'),
          }, {
            title: t('openRequests'),
            value: 2,
            isNumeric: true,
            note: t('dataUpdateUnderReview'),
          }, {
            title: t('lastLogin'),
            value: t('daysAgo'),
            isNumeric: false,
            note: t('fromDesktop'),
          }], [t]).map((item, idx) => (
            <article
              key={idx}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 flex flex-col justify-between hover:shadow-xl transition-all"
            >
              <div className={isRTL ? 'text-right' : 'text-left'}>
                <h2 className="text-sm text-sa-600 font-semibold mb-2">{item.title}</h2>
                {item.isNumeric ? (
                  <CountUpAnimation 
                    end={item.value} 
                    duration={2}
                    suffix={item.suffix || ''}
                    className="text-3xl font-bold text-gray-900 mb-1"
                  />
                ) : (
                  <p className="text-3xl font-bold text-gray-900 mb-1">{item.value}</p>
                )}
              </div>
              <p className={`text-sm text-gray-500 ${isRTL ? 'text-right' : 'text-left'}`}>{item.note}</p>
            </article>
          ))}
        </section>

        <section className="mb-12">
          <div className={`mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
            <h2 className="text-2xl font-bold text-gray-900">{t('myData')}</h2>
            <p className="text-sm text-gray-600">{t('myDataDesc')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {employeeSections.map((section, index) => (
              <article
                key={index}
                className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-transform duration-300 hover:-translate-y-1 flex flex-col"
              >
                <h3 className={`text-lg font-bold text-gray-900 mb-2 ${isRTL ? 'text-right' : 'text-left'}`}>{section.title}</h3>
                <p className={`text-sm text-gray-600 mb-4 leading-relaxed flex-grow ${isRTL ? 'text-right' : 'text-left'}`}>{section.description}</p>
                <Link
                  to={section.link}
                  className={`mt-auto inline-flex justify-center px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-300 ${section.disabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed pointer-events-none' : 'bg-sa-600 text-white hover:bg-sa-700'}`}
                >
                  {t('viewDetails')}
                </Link>
              </article>
            ))}
          </div>
        </section>
        
      </main>
    </div>
  );
};

export default Dashboard;
